import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { CertificationFormItem } from '../../contactSchema';
import { defaultFormValues } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const empty = (): CertificationFormItem => ({ name: '' });

export const CertificationsSection = withForm({
  defaultValues: defaultFormValues,
  render: function CertificationsSection({ form }) {
    return (
      <SectionCard
        title="Certifications & licenses"
        actions={<AddItemButton onClick={() => form.pushFieldValue('certifications', empty())} />}
      >
        <form.AppField name="certifications">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove certification">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <form.AppField name={`certifications[${i}].name`}>
                      {(f) => <f.TextField label="Name" required />}
                    </form.AppField>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`certifications[${i}].issuer`}>
                        {(f) => <f.TextField label="Issuer" />}
                      </form.AppField>
                      <form.AppField name={`certifications[${i}].credentialId`}>
                        {(f) => <f.TextField label="Credential ID" />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`certifications[${i}].issuedOn`}>
                        {(f) => <f.DatePicker label="Issued on" />}
                      </form.AppField>
                      <form.AppField name={`certifications[${i}].expiresOn`}>
                        {(f) => <f.DatePicker label="Expires on" />}
                      </form.AppField>
                      <form.AppField name={`certifications[${i}].url`}>
                        {(f) => <f.TextField label="URL" placeholder="https://..." />}
                      </form.AppField>
                    </div>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
